import { FUND_EXIT_ENTERPRISE_ALIAS, FUND_EXIT_EQUITY_ALIAS } from 'common/constants/allocations';
import { Units } from 'common/types/format';
import { createUnitAwareInputPolicy, UnitAwareInputPolicy } from 'components/Spreadsheet/utilities';
import {
  EXIT_ENTERPRISE_VALUE_ALIAS,
  EXIT_EQUITY_ALIAS,
  FOREIGN_LESS_DEBT_ALIAS,
  FOREIGN_PLUS_CASH_ALIAS,
  LESS_DEBT_ALIAS,
  PLUS_CASH_ALIAS,
} from 'pages/Waterfall/SpreadsheetConfig/constants';

const WATERFALL_UNIT_AWARE_INPUT_ALIASES = new Set([
  EXIT_EQUITY_ALIAS,
  EXIT_ENTERPRISE_VALUE_ALIAS,
  FUND_EXIT_EQUITY_ALIAS,
  FUND_EXIT_ENTERPRISE_ALIAS,
  PLUS_CASH_ALIAS,
  LESS_DEBT_ALIAS,
  FOREIGN_PLUS_CASH_ALIAS,
  FOREIGN_LESS_DEBT_ALIAS,
]);

interface CreateWaterfallInputUnitPolicyOptions {
  enabled: boolean;
  units: Units;
}

export const createWaterfallInputUnitPolicy = ({
  enabled,
  units,
}: CreateWaterfallInputUnitPolicyOptions): UnitAwareInputPolicy =>
  createUnitAwareInputPolicy({
    enabled,
    units,
    isEligible: ({ alias }) => alias != null && WATERFALL_UNIT_AWARE_INPUT_ALIASES.has(alias),
  });
